import { PartialRecord } from '@scale/shared/types/utils';
import { useMemo } from 'react';
import {
  useAuditActions,
  useSpeedAuditResults,
} from 'react-scale/components/ExpertManagement/stores/audit.store';
import { SpeedAuditResult } from 'react-scale/components/audits/SpeedAudit/types';
import { Actions } from 'react-use-v13/lib/useMap';

export const useSpeedAuditResultsMap = (): {
  speedAuditResults: PartialRecord<string, SpeedAuditResult>;
  speedAuditResultsActions: Actions<PartialRecord<string, SpeedAuditResult>>;
} => {
  const speedAuditResults = useSpeedAuditResults();
  const { setAuditResults, deleteAuditResults, resetAuditResults } = useAuditActions();

  const speedAuditResultsActions = useMemo(
    () => ({
      get: (key: string) => speedAuditResults[key],
      set: (key: string, value: SpeedAuditResult | undefined) => setAuditResults(key, value),
      remove: (key: string) => deleteAuditResults(key),
      reset: () => resetAuditResults(),
    }),
    [deleteAuditResults, resetAuditResults, setAuditResults, speedAuditResults],
  );

  return {
    speedAuditResults,
    speedAuditResultsActions,
  };
};
